import React, { useState } from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';
import CustomModal from './CustomModal';
import Image from './Image';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PropertyHeroButtons = ({
  video,
  toggleImagesModal,
  imagesModal,
  floorplan,
  virtualtour,
  sliderText
}) => {
  const customVideoStyles = {
    navigationNext: (base) => ({
      ...base,
      position: 'fixed',
      "@media all and (max-width: 810px)": {
        top: 'unset',
        right: '25%',
        bottom: '10%'
      }
    }),
    view: () => ({ textAlign: 'center', width: '200%' }),
    navigationPrev: (base) => ({
      ...base,
      position: 'fixed',
      "@media all and (max-width: 810px)": {
        top: 'unset',
        left: '25%',
        bottom: '10%'
      }
    })
  }
  const MultiVideoView = (carouselProps) => {
    return (
      <iframe
        title={`https://www.youtube.com/embed/${carouselProps.currentView}`}
        className='multi-video-slider'
        src={`https://www.youtube.com/embed/${carouselProps.currentView}`}
        autoPlay='true'
        frameBorder='0'
        width="600"
        height="400"
        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen></iframe>
    );
  };

  const VirtualTourView = (virtualTourProps) => {
    return (
      <iframe
        title={`https://my.matterport.com/show/?m=${virtualTourProps.currentView}`}
        className='multi-video-slider'
        src={`https://my.matterport.com/show/?m=${virtualTourProps.currentView}`}
        autoPlay='true'
        frameBorder='0'
        width="600"
        height="400"
        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; xr-spatial-tracking'
        allowFullScreen></iframe>
    );
  };

  const modalFloorplan = !!floorplan
    ? floorplan.map((image) => ({ src: image.image }))
    : null;

  const [isVideoModalOpen, setVideoModalStatus] = useState(false);
  const toggleVideoModal = () => {
    if (isVideoModalOpen) {
      return setVideoModalStatus(false);
    }
    return setVideoModalStatus(true);
  };

  const [isVirtualTourModalOpen, setVirtualTourModalStatus] = useState(false);
  const toggleVirtualTourModal = () => {
    if (isVirtualTourModalOpen) {
      return setVirtualTourModalStatus(false);
    }
    return setVirtualTourModalStatus(true);
  };

  const [isFloorplanModalOpen, setFloorplanModalStatus] = useState(false);
  const toggleFloorplanModal = () => {
    if (isFloorplanModalOpen) {
      return setFloorplanModalStatus(false);
    }
    return setFloorplanModalStatus(true);
  };

  const renderFloorplan = () => {
    if (!floorplan || floorplan === '') {
      return null;
    }
    return (
      <ModalGateway>
        {isFloorplanModalOpen ? (
          <Modal onClose={toggleFloorplanModal} closeOnBackdropClick>
            <Carousel
              styles={{ view: () => ({ maxWidth: '70vw', margin: '0 auto', maxHeight: '90vh', objectFit: 'contain', height: '90vh' }) }}
              currentIndex={imagesModal.index}
              views={modalFloorplan}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    );
  };

  const renderVideos = () => {
    if (!video) {
      return null;
    }
    if (video.indexOf(',') > -1) {
      const videoArray = video.split(', ');
      return (
        <ModalGateway>
          {isVideoModalOpen ? (
            <Modal onClose={toggleVideoModal} closeOnBackdropClick>
              <Carousel
                styles={customVideoStyles}
                currentIndex={imagesModal.index}
                views={videoArray}
                interactionIsIdle={false}
                components={{ View: MultiVideoView }}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      );
    }
    return (
      <CustomModal onClose={toggleVideoModal} isOpen={isVideoModalOpen}>
        <iframe
          className='youtube-embed'
          title={`https://www.youtube.com/embed/${video}`}
          src={`https://www.youtube.com/embed/${video}`}
          autoPlay
          frameBorder='0'
          allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen></iframe>
      </CustomModal>
    );
  };

  const renderVirtualTour = () => {
    if (!virtualtour) {
      return null;
    }
    if (virtualtour.indexOf(',') > -1) {
      const virtualtourArray = virtualtour.split(', ');
      return (
        <ModalGateway>
          {isVirtualTourModalOpen ? (
            <Modal onClose={toggleVirtualTourModal} closeOnBackdropClick>
              <Carousel
                styles={customVideoStyles}
                currentIndex={virtualtour.index}
                views={virtualtourArray}
                interactionIsIdle={false}
                components={{ View: VirtualTourView }}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      );
    }
    return (
      <CustomModal onClose={toggleVirtualTourModal} isOpen={isVirtualTourModalOpen}>
        <iframe
        title={`https://my.matterport.com/show/?m=${virtualtour}`}
        className='modal-slider matterport-iframe'
        src={`https://my.matterport.com/show/?m=${virtualtour}`}
        frameBorder='0'
        allow='xr-spatial-tracking'
        allowFullScreen></iframe>
      </CustomModal>
    );
  };


  const renderVideosButton = () => {
    if (!!video) {
      return (
        <button
          onClick={() => toggleVideoModal()}
          className='btn btn-main property-tour-button'>
          { sliderText.video }
        </button>
      );
    }
    return null;
  }

  const renderVirtualTourButton = () => {
    if (!!virtualtour) {
      return (
        <button
          onClick={() => toggleVirtualTourModal()}
          className='btn btn-main property-tour-button'>
          { sliderText.virtualTour }
        </button>
      );
    }
    return null;
  }

  const renderFloorplanButton = () => {
    if (!!floorplan) {
      return (
        <button
          onClick={() => toggleFloorplanModal()}
          className='btn btn-main property-tour-button'>
          { sliderText.floorplan }
        </button>
      );
    }
    return null;
  }
  return (
    <div>
      <div className="property-tour-button-container">
        <button
          onClick={() => toggleImagesModal()}
          className='btn btn-main property-tour-button'>
          { sliderText.photo }
        </button>
        { renderVirtualTourButton() }
        { renderVideosButton() }
        { renderFloorplanButton() }
      </div>
      { renderVirtualTour() }
      {renderVideos()}
      {renderFloorplan()}
    </div>
  );
};

export default PropertyHeroButtons;